import { Skeleton } from '~/components/Skeleton';
import { cn } from '~/lib/cn';

interface SkeletonContactCardProps {
  cardWidth: string;
  titleClassName: string;
  infoClassName: string;
}

export function SkeletonContactCard({
  cardWidth,
  titleClassName,
  infoClassName,
}: SkeletonContactCardProps) {
  return (
    <div className="flex flex-col items-start gap-lg rounded-sm p-md bg-level-04">
      <div className={cn('flex flex-col', cardWidth)}>
        <Skeleton className={cn('rounded-sm bg-level-05', titleClassName)} />
        <div className="h-[0.75em]" />
        <Skeleton className={cn('rounded-sm bg-level-05', infoClassName)} />
        <div className="h-[2em]" />
        <Skeleton className={cn('rounded-sm bg-level-05', infoClassName)} />
        <div className="h-[0.75em]" />
        <Skeleton className={cn('rounded-sm bg-level-05', infoClassName)} />
      </div>
    </div>
  );
}

SkeletonContactCard.displayName = 'SkeletonContactCard';
